import { useEffect, useRef, useState } from "react";
import { Renderer } from "vexflow4";
import SingleStaveHandler from "../common/singleStaveHandler";
import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';
import QuestionsTopNavBar from "../components/QuestionsTopNavBar";
import { doPostMessage } from "../utils/rn";


const ViewQuestion = () => {
    const [questionConfig, setQuestionConfig] = useState('');
    const [isLianEr, setIsLianEr] = useState(false);

    const [handler, setHandler] = useState<SingleStaveHandler | null>(null);

    const staveRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const question_config = localStorage.getItem('question_config') || '';
        setQuestionConfig(question_config);

        doPostMessage('', 'loaded');
        renderQuestion();
    }, []);

    const initStave = (data: any) => {
        const question_type = localStorage.getItem('question_type') || 'YinCheng';

        ['YinCheng', 'HeXian'].indexOf(question_type) !== -1 ? localStorage.setItem('yincheng_tone', data.key) : localStorage.removeItem('yincheng_tone');

        const render = new Renderer(staveRef.current ?? '', Renderer.Backends.CANVAS);
        render.resize(window.innerWidth, window.innerHeight / 2);
        const handler = SingleStaveHandler.getInstance(render);

        const question_user_answer = localStorage.getItem('question_user_answer') || '';
        const userAnswer = JSON.parse(question_user_answer);

        userAnswer?.map((stave: any) => {
            handler.setStaveNotes(stave.notes);
        })

        handler.duration = 'w';
        handler.init();
        handler.redraw();
        setHandler(handler);
    };

    const renderQuestion = () => {
        try {
            const question_config = localStorage.getItem('question_config') || '';
            setQuestionConfig(question_config);

            const question_type = localStorage.getItem('question_type') || 'YinCheng';
            const is_lian_er = ['LianErYinCheng', 'LianErHeXian', 'LianErDanYin'].indexOf(question_type) !== -1;
            setIsLianEr(is_lian_er);
                
            const config = JSON.parse(question_config);
            initStave(config);
            handler?.redraw();
        } catch (e) {
            console.log('render qestioin error', e);
        }
    }

    return (
        <>
            {isLianEr && <QuestionsTopNavBar handler={handler} isLianEr={isLianEr} dataJson={JSON.parse(questionConfig)} />}
            <div id="viewQuestion" onClick={renderQuestion}></div>
            <div style={{ width: '100%', height: '50%' }}>
                <canvas style={{ width: '100%', height: '50%' }} ref={staveRef} />
            </div>
        </>
    );
};

export default ViewQuestion;
